<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Search user</h4>

    </div>
      <div class="col-md-12 card" style="margin:auto;margin-bottom:30px;">
        <div class="card-body row">
    <div class="col-md-4" style="margin-top:auto;margin-left:auto;">
      <fg-input>
        <el-select class="select-primary"
                   size="large"
                   placeholder="Single Select"
                   v-model="selected">
          <el-option v-for="option in select.category"
                     class="select-primary"
                     :value="option.value"
                     :label="option.label"
                     :key="option.label">
          </el-option>
        </el-select>
      </fg-input>
    </div>

          <div class="col-md-2" style="margin-right:auto;">
            <button type="button" class="btn btn-primary" v-on:click="getUsers()">Apply</button>
          </div>
          <div class="col-sm-2">
            <div class="pull-right">
              <button type="submit" class="btn btn-success btn-fill" style="" @click.prevent="createUser">
                Add
              </button>
            </div>
          </div>
        </div>
  </div>
    <div class="col-md-12 card" v-if="tableData.length > 0">
      <div class="card-header">
        <div class="category">Users</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="Search"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column
                              v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <el-table-column
              class-name="action-buttons td-actions"
              align="center"
              label="Edit">
              <template slot-scope="props">
                <p-button type="success" size="sm" icon @click="handleEdit(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination,
      PSwitch,
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue
              if(row[key]) {
                rowValue = row[key].toString().toLowerCase()
              } else {
                rowValue = ''
              }

              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          });
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        selected: 'agent',
        select: {
          category: [{ value: 'agent', label:'agent'}, { value: 'commercial', label:'commercial'}, { value: 'supplier', label:'supplier'}]
        },
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['login', 'role', 'email', 'phone'],
        tableColumns: [
          {
            prop: 'login',
            label: 'Login',
            minWidth: 200
          },
          {
            prop: 'role',
            label: 'Role',
            minWidth: 150
          },
          {
            prop: 'email',
            label: 'Email',
            minWidth: 150
          },
          {
            prop: 'phone',
            label: 'Phone',
            minWidth: 150
          }
        ],
        tableData: []
      }
    },
    mounted() {
    },
    methods: {
      handleEdit (index, row) {
        this.$router.push({path: '/pages/user?id=' + row._id});
      },
      createUser() {
        this.$router.push({path: '/pages/add-user'});
      },
      getUsers() {
        this.$http({
          method: 'get',
          url: this.$apiUrl + '/user/users',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          params: {type : this.selected},
        }).then(response => (
          this.tableData = response.data
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
    }
  }
</script>
<style lang="scss">
  .el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
  }
</style>
